module.exports = __webpack_public_path__ + "media/images/icons/filled/box-plot-17d718593d3f4481133405fb7a3dd251.svg";